import Tr from "translations/Translations";
const MINUTE_SECONDS = 60;
const HOUR_SECONDS = 60 * MINUTE_SECONDS;
const DAY_SECONDS = 24 * HOUR_SECONDS;
const zeroTable = [0, 0, 0, 0];


export const getDays = (sec) => {
    return Math.floor(sec / DAY_SECONDS);
}

export const getDaysHoursMinutesSeconds = (sec, zeroValue = zeroTable) => {
    if (sec <= 0) {
        return zeroValue;
    }

    let secLeft = sec;
    const days = Math.floor(sec / DAY_SECONDS);

    secLeft = secLeft - (days * DAY_SECONDS);
    const hours = Math.floor(secLeft / HOUR_SECONDS);

    secLeft = secLeft - (hours * HOUR_SECONDS);
    const minutes = Math.floor(secLeft / MINUTE_SECONDS);

    secLeft = secLeft - (minutes * MINUTE_SECONDS)
    const seconds = secLeft;
    return [days, hours, minutes, seconds];
}

export const  formatDaysHoursMinutesSeconds = (table) => {

    if(!table || table.length !== 4) {
        return "";
    }
    let ret = '';
    if(table[0] > 0) {
        ret += table[0] + ' ' + Tr('day')
    }
    if(table[1] > 0) {
        ret += " " + table[1] + ' ' + Tr('hours')
    }
    if(table[2] > 0) {
        ret += " " + table[2] + ' ' + Tr('min')
    }
    if(table[3] > 0) {
        ret += " " + table[3] + ' ' + Tr('seconds')
    }
    return ret;
}